import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Medição IMC',
  path: '/merenda/medicaoIMC',
  name: 'medicaoIMC',
  component: () => import('@/views/merenda/medicaoIMC/Index.vue'),
  meta: {
   permissions: [
    eTipoPermissao.MEDICAOIMC_MENU_1000600050
   ],
  },
  goesToMenu: true,
 },
]

